import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { Snackbar as SnackbarMaterial } from '@mui/material';
import { Alert } from '@mui/material';

import SnackbarModel from 'models/shared/SnackbarModel';

interface SnackbarProps {
    snackbar: SnackbarModel;
}

const Snackbar: FC<SnackbarProps> = ({ snackbar }) => (
    <SnackbarMaterial
        open={snackbar.isOpen}
        onClose={(e) => snackbar.hide()}
        autoHideDuration={snackbar.autohideDuration}
    >
        {snackbar.message ? (
            <Alert
                severity={snackbar.severity}
                style={{ display: 'flex', alignItems: 'center' }}
            >
                {snackbar.message}
            </Alert>
        ) : (
            snackbar.Component
        )}
    </SnackbarMaterial>
);

export default observer(Snackbar);
